<template>
  <div class="form-material mt-3 container-fluid">
    <div class="row px-2">
      <div class="form-group col-lg-2 col-4">
        <div class="form-group form-default">
          <input v-model="name" class="form-control" type="text" />
          <span class="form-bar"></span>
          <label class="float-label ml-1" :class="{'fill': name}">Code</label>
        </div>
      </div>
      <div class="form-group col-lg-1 col-4">
        <div class="form-group form-default">
          <input v-model="id" class="form-control" type="text" />
          <span class="form-bar"></span>
          <label class="float-label ml-1" :class="{'fill': id}">ID</label>
        </div>
      </div>
      <div class="form-group col-lg-1 col-4">
        <div class="form-group form-default">
          <input v-model="reference" class="form-control" type="text" />
          <span class="form-bar"></span>
          <label class="float-label ml-1" :class="{'fill': reference}">Reference</label>
        </div>
      </div>
      <div class="form-group col-lg-1 col-12 d-flex justify-content-center d-md-block mt-0 mt-md-4">
        <button type="button" class="btn btn-primary my-0" @click="find()" :disabled="processing">Find</button>
      </div>
      <div class="form-group col-lg-4 col-12 d-flex justify-content-center d-md-block mt-0 mt-md-4">
        <span v-for="(location, id) of locations" :class="{'fw-bold': url == id}" 
              :key="id" class="mx-1 cursor-pointer" @click="url = id">
          {{ id }}
        </span>
      </div>
      <div class="form-group col-lg-2 col-12 d-flex justify-content-center d-md-block mt-0 mt-md-4">
        <span :class="{'fw-bold': language == 'EN'}" class="mx-1 cursor-pointer" @click="language = 'EN'"> 
          EN
        </span>
        <span :class="{'fw-bold': language == 'SP'}" class="mx-1 cursor-pointer" @click="language = 'SP'"> 
          ES
        </span>
        <span :class="{'fw-bold': language == 'DE'}" class="mx-1 cursor-pointer" @click="language = 'DE'"> 
          DE
        </span>
      </div>
    </div>
    <div class="d-flex w-100 justify-content-md-end justify-content-center mb-3">
      <search-box class="col-md-3 col-12" v-model="search" :material="true"></search-box>
    </div>
    <div class="row" v-if="filteredPCMs.length > 0">
      <table class="table table-striped table-sm table-bordered responsive-stack d-flex d-md-table">
        <thead>
          <tr>
            <th scope="col">Name</th>
            <th scope="col">ID</th>
            <th scope="col">Reference</th>
            <th scope="col">Usuario</th>
            <th scope="col">Date</th>
            <th scope="col">Mostrar Precios</th>
            <th scope="col">Detalle</th>
            <th scope="col">URL</th>
          </tr>
        </thead>
        <tbody class="w-100">
          <tr v-for="(pcm, index) of filteredPCMs" :key="'S-' + index">
            <td data-label="Name">{{ pcm.NAME }}</td>
            <td data-label="ID" class="text-right">{{ pcm.PCM_ID }}</td>
            <td data-label="Reference" class="text-right">{{ pcm.REFERENCE }}</td>
            <td data-label="Usuario" class="text-right">{{ pcm.INIT }}</td>
            <td data-label="Date" class="text-right">{{ toDateTime(pcm.DATE_ENTERED) }}</td>
            <td data-label="Mostrar Precios" class="text-right">{{ pcm.ANALYSIS6 }}</td>
            <td data-label="Detalle" class="text-center cursor-pointer" 
                @click="$router.push({ name: 'PCMCost', params: { id: pcm.PCM_ID } })">
              $
            </td>
            <td data-label="URL" class="text-left">
              <div class="d-flex align-items-center">
                <a :href="getURL(pcm)" target="_blank" class="text-truncate me-2">
                  {{ getURL(pcm) }}
                </a>
                <Transition mode="out-in">
                  <a class="cursor-pointer text-nowrap" @click="copyURL(pcm, index)" v-if="!copied[index]">Copy</a>
                  <span v-else class="text-nowrap">✓ <i class="ml-1">Copied!</i></span>
                </Transition>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
var moment = require('moment');
import SearchBox from "@/components/tools/SearchBox.vue";
const api = window.api;
const localUrl = window.location.origin;
var locations = {
  sayhueque: 'https://yourtrip.sayhueque.com',
  saysouthamerica: 'https://yourtrip.saysouthamerica.com',
  yourtrip: 'https://yourtrip.sayyourtrip.com',
  testing: 'https://test-itinerario.sayhueque.com'
};
var defLocation = 'sayhueque';
if (process.env.NODE_ENV == 'development') {
  locations.local = localUrl;
  defLocation = 'local';
}

export default {
  name: 'SayPCM',
  components: {
    SearchBox,
  },
  data() {
    return {
      name: '',
      id: null,
      reference: null,
      pcms: [],
      url: defLocation,
      language: 'EN',
      processing: false,
      copied: {},
      locations: locations,
      search: ''
    };
  },
  computed: {
    filteredPCMs() {
      if (!this.pcms || !Array.isArray(this.pcms)) {
        return [];
      }
      if (!this.search) return this.pcms;
      
      const searchLower = this.search?.toLowerCase();
      return this.pcms.filter((pcm) => {
        return (
          pcm.PCM_ID?.toString().toLowerCase().includes(searchLower) ||
          pcm.NAME?.toLowerCase().includes(searchLower) ||
          pcm.REFERENCE?.toLowerCase().includes(searchLower) ||
          pcm.INIT?.toLowerCase().includes(searchLower)
        );
      });
    },
  },
  methods: {
    async find() {
      this.processing = true;
      this.$store.commit('setProcessing', true);
      let filters = {};
      if (this.name) filters.name = this.name;
      if (this.id) filters.id = this.id;
      if (this.reference) filters.reference = this.reference;
      let res = await api.get('/api/tpsql/find_pcm', filters, 
        (err) => { console.log(err), this.processing = false });
      this.processing = false;
      this.$store.commit('setProcessing', false);
      if (res) {
        this.pcms = res;
      }
      return res;
    },
    toDateTime(d) {
      return moment(d).format('DD MMM YYYY');
    },
    getURL (pcm) {
      let url = this.locations[this.url];
      if (this.url == 'local') {
        url = url.replace('8081', '8082');
      }
      return `${url}/trip?ID=${pcm.PCM_ID}&Code=${pcm.REFERENCE}&Lang=${this.language}`;
    },
    copyURL(pcm, index) {
      navigator.clipboard.writeText(this.getURL(pcm));
      this.copied[index] = true;
      this.copied = Object.assign({}, this.copied);
      setTimeout(() => {
        this.copied[index] = false;
        this.copied = Object.assign({}, this.copied);
      }, 5000);
    }
  }
};
</script>

<style scoped>
.text-right {
  text-align: right !important;
}
.text-left {
  text-align: left !important;
}
.bold {
  font-weight: bold !important;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

@media (max-width: 767.98px) {
  .responsive-stack {
    display: block;
  }
  .responsive-stack thead {
    display: none;
  }
  .responsive-stack tr {
    display: block;
    margin-bottom: 1rem;
  }
  .responsive-stack td {
    display: block;
    text-align: left !important;
    position: relative;
    padding-left: 50%;
  }
  .responsive-stack td::before {
    content: attr(data-label);
    position: absolute;
    left: 0.5rem;
    width: 45%;
    font-weight: bold;
  }
}
</style>